import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { SubjectManagmentService } from '../../../Services/subject-management/subject-management.service';
import { AddQuestionByIDModel } from 'src/app/Models/AddQuestionByID';
import { ToastrService } from 'ngx-toastr';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
@Component({
  selector: 'app-relocate-question',
  templateUrl: './relocate-question.component.html',
  styleUrls: ['./relocate-question.component.css'],
})
export class RelocateQuestionComponent implements OnInit {
  @Input() subjectById: any;
  @Input() getQuestionByIDlist: any;
  @Output() CloseRelocateQuestion: EventEmitter<any> = new EventEmitter<any>();
  @Output() CloseEdit: EventEmitter<any> = new EventEmitter<any>();

  selectedsubject: any;
  subject: any;
  currentsubject: any;
  constructor(
    private cdr: ChangeDetectorRef,
    public QuestionService: QuestionManagementService,
    public service: SubjectManagmentService,
    public toast: ToastrService
  ) {}

  ngOnInit(): void {
    if (Number(this.subjectById.Subject_Id) > 0) {
      this.service
        .getsubjectById({
          CurrentNodeSubjectID: Number(this.subjectById.Subject_Id),
        })
        .subscribe(
          (i: any) => {
            this.currentsubject = i;
            // }).catch((e:any)=> {return null;})
          },
          (error: any) => {
            console.log(error);
          }
        );
      this.service
        .getBreadcrumbDetails({ ID: Number(this.subjectById.Subject_Id) })
        .subscribe(
          (i: any) => {
            let routnodes: any = i;
            routnodes.forEach((i: any) => {
              if (i.Subject_Level_Type_Code === 'S') {
                this.subjectById.Selected_Header_ID = Number(i.Subject_ID);
                this.subjectById.Parent_Subject_Id = Number(i.Subject_ID);
                this.getsubjectbyid(i.Subject_ID);
              }
            });
            // }).catch((e:any)=>{});}
          },
          (error: any) => {
            console.log(error);
          }
        );
    }
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
  Breadcrumblist: any;
  majorTopic: any;
  concept: any;
  subconcept1: any;
  subconcept2: any;
  subconcept3: any;
  subconcept4: any;
  subconcept5: any;
  subconcept6: any;
  mdl_subject: any = 0;
  mdl_majorTopic: any = 0;
  mdl_concept: any = 0;
  mdl_subconcept1: any = 0;
  mdl_subconcept2: any = 0;
  mdl_subconcept3: any = 0;
  mdl_subconcept4: any = 0;
  mdl_subconcept5: any = 0;
  mdl_subconcept6: any = 0;
  currentselectedvalue: any;
  getsubject(key: string, value: any, data: any) {
    try {
      this.currentselectedvalue = data.ChildNodeExistInd;
      console.log(
        this.currentselectedvalue.ChildNodeExistInd,
        'ChildNodeExistInd'
      );
      if (data && key != 'S') {
        if (data.ChildNodeExistInd === 'N') {
          if (key == 'MT' && data.ChildNodeExistInd === 'N') {
            this.majorTopic = null;
            this.concept = null;
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_majorTopic = 0;
            this.mdl_concept = 0;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'C' && data.ChildNodeExistInd === 'N') {
            this.concept = null;
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_concept = 0;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC1' && data.ChildNodeExistInd === 'N') {
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC2' && data.ChildNodeExistInd === 'N') {
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC3' && data.ChildNodeExistInd === 'N') {
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC4' && data.ChildNodeExistInd === 'N') {
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC5' && data.ChildNodeExistInd === 'N') {
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC6' && data.ChildNodeExistInd === 'N') {
            this.subconcept6 = null;
            this.mdl_subconcept6 = 0;
          }
          return;
        }
      }
    } catch {}
    if (key != '' && Number(value.ID) > 0) {
      let list: any = {};
      list['currentNodeID'] = value.ID;
      list['screenName'] = 'SUBJECT BREAKDOWN';
      list['childRecordStatus'] = 'ALL';
      this.service.getSubjectTree(list).subscribe(
        (i: any) => {
          if (key == 'S') {
            this.majorTopic = i;
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
          }
          if (key == 'MT') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.majorTopic = i;
            this.concept = null;
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_concept = 0;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'C') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.concept = i;
            this.subconcept1 = null;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept1 = 0;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC1') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept1 = i;
            this.subconcept2 = null;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC2') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept2 = i;
            this.subconcept3 = null;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept2 = 0;
            this.mdl_subconcept3 = 0;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC3') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept3 = i;
            this.subconcept4 = null;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept4 = 0;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC4') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept4 = i;
            this.subconcept5 = null;
            this.subconcept6 = null;
            this.mdl_subconcept5 = 0;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC5') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept5 = i;
            this.subconcept6 = null;
            this.mdl_subconcept6 = 0;
          } else if (key == 'SC6') {
            this.Breadcrumblist = null;
            this.getBreadcrumbDetails(value.ID);
            this.subconcept6 = i;
          }
          // }).catch((e:any)=>{
          //   this.getBreadcrumbDetails(this.SubjectParentInput.Parent_Subject_Id);
          // });
        },
        (error: any) => {
          this.getBreadcrumbDetails(this.subjectById.Parent_Subject_Id);
          console.log(error);
        }
      );
    } else {
      if (key == 'MT' && value == 0) {
        this.majorTopic = null;
        this.concept = null;
        this.subconcept1 = null;
        this.subconcept2 = null;
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_majorTopic = 0;
        this.mdl_concept = 0;
        this.mdl_subconcept1 = 0;
        this.mdl_subconcept2 = 0;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'C' && value == 0) {
        this.concept = null;
        this.subconcept1 = null;
        this.subconcept2 = null;
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_concept = 0;
        this.mdl_subconcept1 = 0;
        this.mdl_subconcept2 = 0;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC1' && value == 0) {
        this.subconcept1 = null;
        this.subconcept2 = null;
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept1 = 0;
        this.mdl_subconcept2 = 0;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC2' && value == 0) {
        this.subconcept2 = null;
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept2 = 0;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC3' && value == 0) {
        this.subconcept3 = null;
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept3 = 0;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC4' && value == 0) {
        this.subconcept4 = null;
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept4 = 0;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC5' && value == 0) {
        this.subconcept5 = null;
        this.subconcept6 = null;
        this.mdl_subconcept5 = 0;
        this.mdl_subconcept6 = 0;
      } else if (key == 'SC6' && value == 0) {
        this.subconcept6 = null;
        this.mdl_subconcept6 = 0;
      }
    }
  }

  previousNode: any;
  getsubjectbyid(id: number): any {
    this.service.getsubjectById({ CurrentNodeSubjectID: Number(id) }).subscribe(
      (i: any) => {
        this.Breadcrumblist = null;
        this.getBreadcrumbDetails(id);
        this.subject = i;
        if (i.Subject_Level_Type_Code == 'S') {
          this.getsubject('S', { ID: Number(i.Subject_Id) }, null);
        }
        // }).catch((e:any)=> {return null;})
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getBreadcrumbDetails(data: any) {
    this.service.getBreadcrumbDetails({ ID: data }).subscribe(
      (i: any) => {
        this.Breadcrumblist = i;
        // }).catch((e:any)=>{});
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getparentselected() {
    let parentidchanged: boolean = false;
    let currentparentid: Number = this.subjectById.Parent_Subject_Id;

    if (Number(this.mdl_subconcept6.ID > 0)) {
      this.subjectById.Parent_Subject_Id = Number(this.mdl_subconcept6.ID);
    } else if (Number(this.mdl_subconcept5.ID > 0)) {
      this.subjectById.Parent_Subject_Id = Number(this.mdl_subconcept5.ID);
    } else if (Number(this.mdl_subconcept4.ID > 0)) {
      this.subjectById.Parent_Subject_Id = Number(this.mdl_subconcept4.ID);
    } else if (Number(this.mdl_subconcept3.ID > 0)) {
      this.subjectById.Parent_Subject_Id = Number(this.mdl_subconcept3.ID);
    } else if (Number(this.mdl_subconcept2.ID > 0)) {
      this.subjectById.Parent_Subject_Id = Number(this.mdl_subconcept2.ID);
    } else if (Number(this.mdl_subconcept1.ID > 0)) {
      this.subjectById.Parent_Subject_Id = Number(this.mdl_subconcept1.ID);
    } else if (Number(this.mdl_concept.ID > 0)) {
      this.subjectById.Parent_Subject_Id = Number(this.mdl_concept.ID);
    } else if (Number(this.mdl_majorTopic.ID > 0)) {
      this.subjectById.Parent_Subject_Id = Number(this.mdl_majorTopic.ID);
    } else {
      this.subjectById.Parent_Subject_Id = Number(this.subject.Subject_Id);
    }
    if (Number(currentparentid) != Number(this.subjectById.Parent_Subject_Id)) {
      this.getBreadcrumbDetails(this.subjectById.Parent_Subject_Id);
    }
  }
  AddQuestionHeader1() {
    console.log(this.currentselectedvalue, 'currentselectedvalue');
    console.log(this.subjectById, 'currentselectedvalue');
  }
  save_submitted: boolean = false;
  AddQuestionResponse: any;
  Modalclose: boolean;
  AddQuestion: AddQuestionByIDModel;
  AddQuestionHeader() {
    // if (!this.getQuestionByIDlist) {

    this.AddQuestion = this.getQuestionByIDlist[0];
    this.AddQuestion.SubjectId = this.subjectById.Parent_Subject_Id;
    this.AddQuestion.SubjectShortCode = this.subjectById.Subject_Short_Code;
    //this.AddQuestion.Question_ID=this.getQuestionByIDlist[0].Question_ID;

    this.QuestionService.RelocateQuestion(this.AddQuestion).subscribe(
      (i: any) => {
        this.AddQuestionResponse = i;
        if (this.AddQuestionResponse.Message == 'Success') {
          this.toast.success('Question Relocate Successfully');
          this.save_submitted = false;
          // if(this.AddQuestionResponse.Value!=null&&this.AddQuestionResponse.Value!=""){
          //   this.getQuestionByID(this.AddQuestionResponse.Value);
          // }
          // else{
          //   this.getQuestionByID(this.AddQuestionform.controls['Question_ID'].value);
          // }
          this.CloseRelocateQuestion.emit(this.Modalclose);
          this.CloseEdit.emit(this.Modalclose);
        } else {
          this.toast.error(this.AddQuestionResponse.Message);
        }
      },
      (error: any) => {
        this.AddQuestionResponse = error;
        this.toast.error(this.AddQuestionResponse.statusText);
        this.save_submitted = false;
        console.log(error);
      }
    );
    console.log(this.subjectById.Parent_Subject_Id, 'currentsubject');
  }

  Cancel() {
    this.CloseRelocateQuestion.emit(this.Modalclose);
  }
}
